import { Checkbox, FormControl, FormControlLabel, FormLabel } from "@mui/material";
import { styled } from "@mui/styles";



export const FormContainer = styled(FormControl)(() => ({
    "& fieldset.MuiOutlinedInput-notchedOutline": {
        border: "1px solid #c4d8ff !important",
    },
    "& .MuiCheckbox-root": {
        "& input": {
            opacity: 0,
        },
    },
    "& .MuiFormLabel-asterisk": {
        color: "#e5453b",
    },
}));

export const FormContainerCheckbox = styled(FormControl)(() => ({
    "& fieldset.MuiOutlinedInput-notchedOutline": {
        // border: "1px solid #c4d8ff !important",
    },
    "& .MuiCheckbox-root": {
        "& input": {
            opacity: 0,
        },
    },
    "& .MuiFormLabel-asterisk": {
        color: "#e5453b",
    },
}));

export const FormLabelContainer = styled(FormLabel)(() => ({
    fontFamily: 'Roboto, sans-serif',
    fontSize: "14px",
    fontWeight: "bold",
    color: "#2c2f44",
    marginBottom : "12px",
    "&.Mui-focused": {
        color: "#2c2f44",
    },
}));

export const FormControlLabelContainer = styled(FormControlLabel)(() => ({
    fontFamily: "Roboto",
    fontSize: "14px",
    color: "#2c2f44",
    marginBottom: 0,
    textTransform: "none",
    "& .MuiFormControlLabel-label": {
        fontFamily: 'Roboto, sans-serif',
        fontSize: "14px",
        color: "#2c2f44",
    },
}));

export const CheckBoxContainer = styled(Checkbox)(() => ({
    "&:hover": {
        backgroundColor: "rgb(196 216 255 / 18%) !important",
        "& span": {
            boxShadow:
                "0px 2px 1px -1px rgb(0 0 0 / 8%), 0px 1px 1px 0px rgb(0 0 0 / 9%), 0px 0px 0px 0px rgb(0 0 0 / 12%)",
        },
    },
}));

export const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: 4,
    width: 20,
    height: 20,
    border: "solid 1px #c4d8ff",
    ".Mui-focusVisible &": {
        outline: "2px auto rgba(19,124,189,.6)",
        outlineOffset: 2,
    },
    "input:disabled ~ &": {
        boxShadow: "none",
        background:
            theme.palette.mode === "dark" ? "rgba(57,75,89,.5)" : "rgb(0 0 0 / 12%)",
    },
}));

export const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: "red",
    backgroundImage:
        "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
        display: "block",
        width: 18,
        height: 18,
        backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""',
    },
});